export type DebugOptionsType = {
    logTRPCCalls?: boolean
    hideUpcomingFeatures?: boolean
}

export const loadDebugOptions = () => JSON.parse(localStorage.getItem('debug:options') || '{}') as DebugOptionsType
